import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  getTelegramOperations,
  telegramOperationsQueryKey,
  type OperationsWindow,
} from '../api/telegram-operations.client.js';

export function useTelegramOperations(window: OperationsWindow) {
  const scope = useCurrentScope();
  return useQuery({
    queryKey: telegramOperationsQueryKey(scope?.workspaceId ?? 'anonymous', window),
    queryFn: () => getTelegramOperations(window),
    enabled: scope !== null && ['owner', 'admin'].includes(scope.role),
    refetchInterval: 30_000,
  });
}
